import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/common";
import { useGarage } from "@/context/GarageContext";
import { PartsTab } from "@/modules/inventory/PartsTab";
import { SuppliersTab, OrdersTab } from "@/modules/inventory/OrdersTab";
import { t } from "@/i18n";

export default function Inventory() {
  const { isManager, canManage } = useGarage();
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "parts";
  const manage = Boolean(isManager && canManage);
  return (
    <div data-testid="inventory-page">
      <PageHeader title={t("b8.inv.title")} subtitle={manage ? t("b8.inv.subtitle") : t("b8.inv.subtitleMech")} />
      <Tabs value={tab} onValueChange={(v) => setParams({ tab: v })}>
        <TabsList className="mb-6">
          <TabsTrigger value="parts" data-testid="inventory-tab-parts">{t("b8.inv.parts")}</TabsTrigger>
          <TabsTrigger value="suppliers" data-testid="inventory-tab-suppliers">{t("b8.inv.suppliers")}</TabsTrigger>
          {isManager && <TabsTrigger value="orders" data-testid="inventory-tab-orders">{t("b8.inv.orders")}</TabsTrigger>}
        </TabsList>
        <TabsContent value="parts"><PartsTab canManage={manage} /></TabsContent>
        <TabsContent value="suppliers"><SuppliersTab canManage={manage} /></TabsContent>
        {isManager && <TabsContent value="orders"><OrdersTab /></TabsContent>}
      </Tabs>
    </div>
  );
}
